import { render, staticRenderFns } from "./previewInfo.vue?vue&type=template&id=25a90bd8&scoped=true"
import script from "./previewInfo.vue?vue&type=script&lang=js"
export * from "./previewInfo.vue?vue&type=script&lang=js"
import style0 from "./previewInfo.vue?vue&type=style&index=0&id=25a90bd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a90bd8",
  null
  
)

export default component.exports